<template>
  <div id="app" @click="clicked">
    <router-view/>
  </div>
</template>
<script>
    export default{
        name: 'App',
        data (){
            return {
                lTime: new Date().getTime(), // 最后一次点击的时间
                ctTime: new Date().getTime(), //当前时间
                tOut:  20 * 60 * 1000   //超时时间20min
            }
        },
        mounted () {
            window.setInterval(this.tTime, 1000)
        },
        methods:{
            clicked () {
                this.lTime = new Date().getTime()  //当界面被点击更新点击时间
            },
            tTime() {
                this.ctTime = new Date().getTime()
                if (this.ctTime -this.lTime > this.tOut) {
                    // if(sessionStorage.getItem('logined') == '1'){
                        // 退出登录
                      sessionStorage.clear();
                      sessionStorage.setItem('logined','0');
                      sessionStorage.setItem('token','');
                      this.$router.replace('/login');
                    // }
                }
            }
        }
    }
</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  overflow: auto;
}
*{
  padding: 0;
  margin: 0;
  /*box-sizing: border-box;*/
  height: auto;
  font-family: 'MicrosoftYaHei';
}
body,html{
  background: #f0f2f5;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>

